import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";

import AuthLayout from "../pages/_layouts/auth";

export default function RouteWrapper({ component: Component, isPrivate = false, ...rest }) {
	const Layout = AuthLayout;

	return (
		<Route
			{...rest}
			render={(props) => (
				<Layout>
					<Component {...props} />
				</Layout>
			)}
		/>
	);
}

RouteWrapper.prototype = {
	isPrivate: PropTypes.bool,
	data: PropTypes.string,
	component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

RouteWrapper.defaultProps = {
	isPrivate: false,
	data: "DEFAULT",
};
